import { DocReference } from "../../../../types/firebase.types";

export const requestFetchedData = async (ref: DocReference) => {
  const sn = await ref.get();
  return sn.data();
};
